import {SalaryType} from '../../enums/salary-type.enum';
import {SalaryMode} from '../../enums/salary-mode.enum';

export class SalaryModel {
  salary: number;
  salaryMax: number;
  salaryType: SalaryType;
  salaryMode: SalaryMode;
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/interviews/questionnaires/salary.model.ts